import React from 'react';
import { formatDueDate, getDueDateStatus } from '../../utils/dateUtils';
import { parseISO } from 'date-fns';
import {
    DueDateContainer,
    DueDateInfo,
    DueDateText,
    DueDateStatusWrapper,
    DueDateStatusText,
    DueDateActions,
    DueDateCheckbox,
    DueDateLabel
} from '../../styles/CardDueDate.styles';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const CardDueDate = ({ project, cardData, setCardData, saveCardChanges }) => {
    if (!cardData || !cardData.dueDate) {
        return null;
    }

    const handleToggleCompletion = async () => {
        const newIsDueDateCompleted = !cardData.isDueDateCompleted;

        setCardData(prevData => ({
            ...prevData,
            isDueDateCompleted: newIsDueDateCompleted
        }));

        try {
            await saveCardChanges(
                { isDueDateCompleted: newIsDueDateCompleted },
                {
                    type: 'due_date_completion_toggled',
                    details: newIsDueDateCompleted ? 'marked as completed' : 'marked as incomplete'
                }
            );

            const completedColumn = Object.values(project.columns).find(col => col.title === 'Closed');
            if (completedColumn && newIsDueDateCompleted) {
                const sourceColumn = Object.values(project.columns).find(col => col.cards.some(c => c.id === cardData.id));
                if (sourceColumn && sourceColumn.id !== completedColumn.id) {
                    const updatedSourceCards = sourceColumn.cards.filter(c => c.id !== cardData.id);
                    const updatedCompletedCards = [...completedColumn.cards, cardData];
                    const projectRef = doc(db, 'projects', project.id);
                    await updateDoc(projectRef, {
                        [`columns.${sourceColumn.id}.cards`]: updatedSourceCards,
                        [`columns.${completedColumn.id}.cards`]: updatedCompletedCards
                    });
                }
            }
        } catch (error) {
            console.error("Error saving due date completion status:", error);
            setCardData(prevData => ({
                ...prevData,
                isDueDateCompleted: !newIsDueDateCompleted
            }));
        }
    };

    const parsedDate = typeof cardData.dueDate === 'string' ? parseISO(cardData.dueDate) : cardData.dueDate;
    const formattedDateString = formatDueDate(parsedDate, cardData.isDueDateCompleted);
    const dueDateStatus = getDueDateStatus(parsedDate, cardData.isDueDateCompleted);

    return (
        <DueDateContainer>
            <DueDateInfo>
                <DueDateText className={cardData.isDueDateCompleted ? 'completed' : ''}>
                    {formattedDateString}
                </DueDateText>
                <DueDateStatusWrapper>
                    <DueDateStatusText color={dueDateStatus.color}>
                        {dueDateStatus.text}
                    </DueDateStatusText>
                    <DueDateActions>
                        <DueDateCheckbox
                            type="checkbox"
                            id={`dueDateComplete-${cardData.id}`}
                            checked={cardData.isDueDateCompleted || false}
                            onChange={handleToggleCompletion}
                        />
                        <DueDateLabel htmlFor={`dueDateComplete-${cardData.id}`}>
                            Mark as complete
                        </DueDateLabel>
                    </DueDateActions>
                </DueDateStatusWrapper>
            </DueDateInfo>
        </DueDateContainer>
    );
};

export default CardDueDate;
